import getEnvironmentVariable from '@infotech/helper-get-enviroment-variable'

export const LOGGER_SERVICE = getEnvironmentVariable(`REACT_APP_LOGGER_SERVICE`, process.env.REACT_APP_LOGGER_SERVICE)
